import { useEffect, useRef, useState } from 'react';

export const useCountUp = (end, duration = 2000, shouldStart = false) => {
  const [count, setCount] = useState(0);
  const hasStartedRef = useRef(false);
  const startTimeRef = useRef(null);

  useEffect(() => {
    // Якщо анімація ще не запускалась І shouldStart = true, запускаємо
    if (!hasStartedRef.current && shouldStart) {
      hasStartedRef.current = true;
      
      const numericEnd = parseInt(end);

      const animate = (currentTime) => {
        if (!startTimeRef.current) {
          startTimeRef.current = currentTime;
        }

        const elapsed = currentTime - startTimeRef.current;
        const progress = Math.min(elapsed / duration, 1);

        // Easing function
        const easeOutQuart = 1 - Math.pow(1 - progress, 4);
        const current = Math.floor(easeOutQuart * numericEnd);

        setCount(current);

        if (progress < 1) {
          requestAnimationFrame(animate);
        } else {
          setCount(numericEnd);
        }
      };

      requestAnimationFrame(animate);
    }
  }, [end, duration, shouldStart]);

  // Format the output
  const formatCount = () => {
    if (typeof end === 'string') {
      if (end.includes('+')) return `${count}+`;
      if (end.includes('%')) return `${count}%`;
    }
    return count;
  };

  return formatCount();
};

export const useInView = (options = {}) => {
  const [isInView, setIsInView] = useState(false);
  const [hasAnimated, setHasAnimated] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // Запускаємо анімацію тільки один раз
      if (entry.isIntersecting && !hasAnimated) {
        setIsInView(true);
        setHasAnimated(true);
      }
      // Після анімації залишаємо isInView = true, щоб показувати фінальне значення
    }, {
      threshold: 0.4, // Зменшено для раннього спрацювання
      rootMargin: '0px',
      ...options
    });

    const currentRef = ref.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [hasAnimated, options]);

  return [ref, isInView];
};
